import React, { useState, useContext } from "react";
import {
  Paper,
  TableBody,
  InputAdornment,
  TableRow,
  TableCell,
  Input,
} from "@material-ui/core";
import useTable from "../../hooks/useTable";
import { UserContext } from "../../context/UserContext";
import ModalView from "../modal/AdminFormModal";
import _ from "lodash";
import { Search } from "@material-ui/icons";
import { PERMITTED_ROLES } from "../../constants/UserRoles";

const headCells = [
  { id: "actions", width: "5%", label: "Actions", disableSorting: true },
  { id: "SAMAccountName", width: "10%", label: "Username" },
  { id: "role", width: "10%", label: "Role" },
  { id: "Department", width: "20%", label: "Departments" },
  { id: "FirstName", width: "10%", label: "First Name" },
  { id: "LastName", width: "10%", label: "Last Name" },
  { id: "Email", width: "25%", label: "Email ID" },
];
const columns = [
  "SAMAccountName",
  "Department",
  "role",
  "FirstName",
  "LastName",
  "Email",
];

export default function UserGriddle() {
  const { lists, userList, onUpdateUser } = useContext(UserContext);
  const [modalView, setView] = useState({});
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    isVisible,
  } = useTable(userList, headCells, filterFn, "");
  const { RAW_USER_ROLES } = PERMITTED_ROLES;
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            _.some(columns, (column) =>
              _.toLower(_.get(x, column)).includes(_.toLower(target.value))
            )
          );
      },
    });
  };

  return (
    <>
      <Paper className="userPageContent">
        <label className="userCountLabel">{_.size(lists) + " Users"}</label>
        <Input
          type="search"
          disableUnderline={true}
          className="userSearchInput"
          startAdornment={
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          }
          onChange={handleSearch}
        />
        {isVisible() ? (
          <>
            <TblContainer>
              <TblHead />
              <TableBody id={"table_container"}>
                {recordsAfterPagingAndSorting().map((item) => (
                  <TableRow key={_.get(item, "SAMAccountName")}>
                    <TableCell key={"user actions"} style={{ width: "5%" }}>
                      {
                        <span>
                          {" "}
                          <i
                            style={{ marginRight: "5px", cursor: "pointer" }}
                            className="material-icons"
                            onClick={(e) => {
                              e.preventDefault();
                              setView(item);
                            }}
                          >
                            mode_edit
                          </i>
                        </span>
                      }
                    </TableCell>
                    <TableCell key={"userName"} style={{ width: "10%" }}>
                      {_.get(item, "SAMAccountName", "")}
                    </TableCell>
                    <TableCell key={"userRole"} style={{ width: "10%" }}>
                      {_.map(
                        Object.values(_.get(item, "AssignedGroups")),
                        (value, index) => (RAW_USER_ROLES.includes(value) && (
                            <React.Fragment key={"assignGroup" + index}>
                              {value}
                              <br />
                            </React.Fragment>
                          ))
                      )}
                    </TableCell>
                    <TableCell key={"deptName"} style={{ width: "20%" }}>
                      {_.map(_.get(item, "Department", ""), (value, index) => (
                        <React.Fragment key={"userDept" + index}>
                          {value}
                          <br />
                        </React.Fragment>
                      ))}
                    </TableCell>
                    <TableCell key={"firstName"} style={{ width: "10%" }}>
                      {_.get(item, "FirstName", "")}
                    </TableCell>
                    <TableCell key={"lastName"} style={{ width: "10%" }}>
                      {_.get(item, "LastName", "")}
                    </TableCell>
                    <TableCell key={"emailId"} style={{ width: "25%" }}>
                      {
                        <a
                          style={{ color: "rgb(44, 130, 190)" }}
                          href={"mailto:" + _.get(item, "Email")}
                        >
                          {_.get(item, "Email", "")}
                        </a>
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </>
        ) : (
          <div className="noResults">No results found</div>
        )}
      </Paper>
      {!_.isEmpty(modalView) ? (
        <ModalView
          item={modalView}
          show={true}
          onComplete={(user, dept) => {
            onUpdateUser(user, dept);
            setView({});
          }}
          onClose={(e) => {
            setView({});
          }}
          mode="admin"
        />
      ) : null}
    </>
  );
}
